export enum partTypeEnum {
    headLeft = 'headLeft',
    body = 'body',
    headRight = 'headRight',
}